import { NgModule, DoBootstrap, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import {
  appConfig,
  errorInterceptor,
  headerInterceptorFn,
} from '@everymatrix-base-components/utils';
import { initializeApp } from './services/initialize-app';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MessageService } from 'primeng/api';

@NgModule({
  imports: [BrowserModule, AppComponent],
  providers: [
    MessageService,
    ...appConfig.providers,
    provideHttpClient(
      withInterceptors([headerInterceptorFn, errorInterceptor])
    ),
    provideAppInitializer(initializeApp),
  ],
})
export class AppModule implements DoBootstrap {
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method,@typescript-eslint/no-empty-function
  ngDoBootstrap(): void {}
}
